import { Timestamp } from '@fullstory/proto/google/protobuf';
import { TRENDS_METRIC_RESPONSE } from '@fullstory/ui-mocks';
import { VISUALIZATION_COLORS } from '../../constants';
import { TrendChartDataSet, TrendPoint } from './TrendsChart';

const TRENDS_METRIC_POINTS =
  TRENDS_METRIC_RESPONSE?.data?.table.map(
    (row, i): TrendPoint => ({
      startDate: Timestamp.toDate(row.startTime) ?? new Date(),
      endDate: Timestamp.toDate(row.endTime) ?? new Date(),
      displayStartDate: Timestamp.toDate(row.startTime) ?? new Date(),
      displayEndDate: Timestamp.toDate(row.endTime) ?? new Date(),
      value: row.value,
      datasetItemIndex: 0,
      comparisonId: `${i}`,
      isPartialPeriod: row.isPartialPeriod,
    }),
  ) ?? [];

export const TRENDS_DATA_SET: TrendChartDataSet<TrendPoint>[] = [
  {
    groups: [],
    label: '',
    id: '',
    points: TRENDS_METRIC_POINTS,
    fill: VISUALIZATION_COLORS[0],
    group: '',
    isComparison: false,
    datasetItemIndex: 0,
    durationUnit: null,
  },
];
